import React from 'react';
import buttonsClasses from 'swag-client-common/styles/buttons.scss';
import { ShortUnderlineInput } from 'swag-client-common/components/inputs/pink-underline-input';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import IncrementNote from 'swag-client-common/components/ui/increment-note';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import getNotificationText from 'swag-common/utils/product/get-notification-text-for-product-quantity.util';
import classnames from 'classnames';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import SharedItemNote from '../shared-item-note/shared-item-note';
import classes from './main-quantity-input.scss';
export function MainQuantityInput(props) {
  const {
    onPriceBreakClick,
    onChange,
    quantity,
    minQuant,
    maxQuant,
    quantIncrement,
    showPriceBreaks,
    number,
    title,
    validateQuantity,
    hasMinimum = true,
    afterInputText = 'printed',
    beforeInputText = 'I would like',
    titleClassName = '',
    subTitleClassName = '',
    inputClassName = '',
    errorClassName = '',
    noteClassName = '',
    noteShiftClassName = '',
    containerClassname = '',
    indicateMainInputStock,
    twoLinesInStockError = true,
    ignoreBigNumber = false,
    disabled = false,
    variants = [],
    stockLevelsByVariantSku,
    isRelated,
    productIsAlwaysInStock,
    sharedItemInfo = {},
    originalSharedItemInfo
  } = props;
  const isStockExceeded = quantity > validateQuantity;
  const errorMessage = getNotificationText({
    totalQuantityWithRelatedItems: isRelated && validateQuantity,
    quantityForCurrentItem: quantity,
    sharedQuantityForCurrentItem: sharedItemInfo.totalQuantity,
    isShared: sharedItemInfo.isSharedItem,
    minQuantity: minQuant,
    maxQuantity: maxQuant,
    quantIncrement: isRelated ? 1 : quantIncrement,
    variants,
    stockLevelsByVariantSku,
    productIsAlwaysInStock
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(productDetailsClasses.row, classes.container, containerClassname)
  }, title || /*#__PURE__*/React.createElement("h5", {
    className: classnames(productDetailsClasses.blockTitle, titleClassName, {
      [productDetailsClasses.titleShift]: !!errorMessage
    })
  }, number && /*#__PURE__*/React.createElement("span", {
    className: classnames(productDetailsClasses.number)
  }, number), beforeInputText, " ", /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "totalQuantity",
    label: "Quantity:"
  }), /*#__PURE__*/React.createElement(ShortUnderlineInput, {
    id: "totalQuantity",
    dataInput: "TotalQuantity",
    className: classnames(inputClassName, classes.input, {
      [classes.bigNumber]: !ignoreBigNumber && quantity > 9999
    }),
    value: quantity,
    onChange: e => onChange(parseInt(e.target.value || '0', 10) || 0),
    disabled: disabled
  }), ' ', afterInputText, hasMinimum && /*#__PURE__*/React.createElement("span", {
    className: classnames(productDetailsClasses.subHeader, subTitleClassName)
  }, ' ', "(Min qty: ", minQuant, ")")), indicateMainInputStock && isStockExceeded && /*#__PURE__*/React.createElement(OutOfStockMessage, {
    className: classnames(classes.outOfStockMessage, {
      [classes.movedLeft]: !!number
    }),
    twoLines: twoLinesInStockError,
    inStockQuantity: validateQuantity
  }), showPriceBreaks && /*#__PURE__*/React.createElement("div", {
    className: productDetailsClasses.buttonContainerRight
  }, /*#__PURE__*/React.createElement("div", {
    className: buttonsClasses.blackTextBorderedButton,
    onClick: onPriceBreakClick,
    "data-button": "PriceBreaks"
  }, "price breaks")), errorMessage && /*#__PURE__*/React.createElement("p", {
    className: classnames(productDetailsClasses.error, errorClassName)
  }, errorMessage)), /*#__PURE__*/React.createElement(SharedItemNote, originalSharedItemInfo), /*#__PURE__*/React.createElement(IncrementNote, {
    className: classnames(noteClassName, {
      [noteShiftClassName || productDetailsClasses.noteShift]: !!errorMessage
    }),
    quantIncrement: quantIncrement,
    minQuant: minQuant
  }));
}